var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIconNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 1.33342C11.6826 1.33342 14.6693 4.32008 14.6693 8.00008C14.6693 11.6801 10.9626 13.9267 10.9626 13.9267M10.9626 13.9267L10.9626 10.9134M10.9626 13.9267L14.2959 13.9267M8.0026 14.6667C4.3226 14.6667 1.33594 11.7067 1.33594 8.00008C1.33594 3.55342 5.0426 1.33342 5.0426 1.33342M5.0426 1.33342L1.70927 1.33342M5.0426 1.33342L5.0426 4.29342",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIconNew);
export default __webpack_public_path__ + "static/media/refreshIconNew.9cb58fe8fcd086ff173628dae47d0ed6.svg";
export { ForwardRef as ReactComponent };